import { createFileRoute, redirect } from "@tanstack/react-router";
import { brandSubRedirectUrl } from "@/components/inventory/FilterRedirects";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/product-palomino/$path/$trim")({
  head: () => pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/product-palomino/:path/:trim' }),
  beforeLoad: ({ params }) => {
    throw redirect({
      href: brandSubRedirectUrl("product-palomino", params.path, params.trim),
      statusCode: 301,
      throw: true,
    });
  },
});
